import React, { useState, useEffect, useRef } from "react";
import { instance } from "../../axios";
import { TableZero, Toastcontent, PageHeader, UiButton, UiPeriodSelect, UiSelect, UiClientSelect, BgLoader, InLoader, UiDateRange, UiActioButton, UiActionDropDown, UiInput, PageError } from "../../ui";
import { useForm, Controller } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { Link, useLocation } from "react-router-dom"
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useQuery, useQueryClient, select } from "react-query";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useStore } from "../../state.js";
import { Helmet } from "react-helmet";
import queryString from 'query-string';
import { CSVLink, CSVDownload } from "react-csv";
import { toast } from "react-toastify";



export default function ComplianceCalender() {
  let navigate = useNavigate();
  const location = useLocation();
  const queryClient = useQueryClient()
  const zstate = useStore((state) => state.clients);
  const setZState = useStore((state) => state.setClients);
  const [dlLoader, showDlLoader] = useState(false);
  const parsed = queryString.parse(location.search);


  let componentRef = useRef();


  const schema = yup.object().shape(
    {
      search: yup.string(),

    }
  );


  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
    control,
    watch,
    formState,
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });



  const onSubmitHandler = async (data) => {

    const obj = {};
    Object.entries(data).map(([key, val]) => {
      if (val) {
        obj[key] = Array.isArray(val) ? (val.map(itm => itm.value)).join(',') : val.label ? val.value + '::' + val.label : val
      }
    })

    const u = new URLSearchParams(obj).toString();

    if (location.search) {
      navigate("/compliance-calendar?" + u, { replace: true })
    } else {
      navigate("/compliance-calendar?" + u)
    }
  };








  const headers = [
    { label: "Due Date", key: "due_date" },
    { label: "Event", key: "event_name" },
    { label: "Period", key: "event_period" },
    { label: "Description", key: "event_desc" },
  ];

  const [state, setState] = useState({});
  const [filter, setFilter] = useState({});



  async function fetchData(filter) {

    const { data } = await instance.get(
      "/compliance_calender" + filter
    );

    var dataa = data;
    return dataa;
  }

  const defaultValues = {
    year: null,
    month: null

  };


  const downloadCalender = () => {
    showDlLoader(true)
    let currentUrlParams = new URLSearchParams(location.search);
    currentUrlParams.set('download_image', '1');
    instance
      .get("/compliance_calender?" + currentUrlParams.toString(), { responseType: "blob" })
      .then(function (response) {
        showDlLoader(false)
        if(response.data.size == 0){
          toast("Something went wrong", { type: "error" });
        } else {
        const fileURL = window.URL.createObjectURL(response.data);

        let alink = document.createElement('a');
        alink.href = fileURL;
        alink.download = 'compliance-calendar.jpeg';
        alink.click();
        }
      })
      .catch(function (error) { showDlLoader(false) })
      .then(function () { showDlLoader(false) });


  }

  useEffect(() => {

    const parsed = queryString.parse(location.search);

    if (location.search) {
    } else {
      //setFilter(defaultValues)
    }



  }, [location]);


  useEffect(() => {


    const parsed = queryString.parse(location.search);

    setFilter(parsed)


  }, []);



  const { data, error, isError, isLoading, isFetching } = useQuery(["compliance_calender", location.search], () => fetchData(location.search), {
    keepPreviousData: true,
    enabled: true
  });



  useEffect(() => {


    const defaultValues1 = {
      period: filter.period,

    };
    reset(defaultValues1)

  }, [filter]);

  const getColor = (text) => {
    switch (text) {
      case "Income Tax":
        return "#3B3B98";
      case "ROC":
        return "#6D214F";
      case "GST":
        return "#58B19F";
      case "PF & ESIC":
        return "#009AFD";
      default:
        return "black";
    }
  };


  if (isLoading) {
    return <BgLoader />;
  }
  if (!data) {
    return (
      <BgLoader />
    )
  }
  if (data.status == 'error') {
    return (
      <PageError msg={data.msg} code={data.code} />
    )
  }
  if (isError) {
    return <div>Error! {error.message}</div>;
  }

  return (
    <>
      <Helmet>
        <title>
          Compliance Calendar | Practive
        </title>
      </Helmet>
      <div>
        <div>
          <PageHeader title="Compliance Calendar" >
            <UiButton className="btn btn-outline-primary me-2" onClick={() => navigate('/compliances-settings')} title="Settings" />
            {(data.items) &&

              <UiButton className="btn btn-primary" onClick={() => downloadCalender()} title="Download" loading={dlLoader}></UiButton>
            }

          </PageHeader>


          <form className="position-relative" onSubmit={handleSubmit(onSubmitHandler)} noValidate>
            <div className="p-3 bg-light rounded mb-4 ">

              <div className="row">



                <div className="col-md-3">
                  <label className="form-label">Period</label>
                  <Controller
                    name="period"
                    control={control}
                    defaultValue={data.period}
                    render={({
                      field: { onChange, onBlur, value, name, ref },
                      fieldState: { invalid, isTouched, isDirty, error },
                      formState,
                    }) => (
                      <UiPeriodSelect

                        onUpdate={onChange}
                        value={value}
                        ref={ref}
                        name={name}
                        menuoptions={['Monthly', 'Quarterly', 'Yearly']}

                      />
                    )}
                  />
                </div>





                <div className="col-md-1" style={{ paddingTop: '28px', minWidth: '50px' }}>
                  <div className="d-flex justify-content-end">

                    <UiActioButton type="submit" className="fs-3 d-none" tooltip="Apply Filter" title="Go" />
                  </div>

                </div>
              </div>



            </div>

          </form>

          <div className="card card-default position-relative">
            {isFetching && <InLoader />}
            <div className="card-body tablecard">




              {data.items &&
                <>
                  {Object.entries(data.items).map(([month, events]) => (
                    <div key={month} className="mb-3">
                      <h2 className="text-uppercase fw-bold">{month}</h2>


                      <div ref={componentRef} className="table-responsive">
                        <table style={{ minWidth: '600px' }} className="table align-middle striped-table table-borderless text-secondary">
                          <colgroup>
                            <col style={{ width: '80px' }} />
                            <col style={{ width: '200px' }} />
                            <col style={{ width: '100px' }} />
                          </colgroup>
                          <thead>
                            <tr>
                              <th>Due Date</th>
                              <th>Form/Event</th>
                              <th>Act</th>
                              <th>Description</th>
                            </tr>
                          </thead>
                          <tbody>
                            {events.map((item, index) => (

                              <tr key={index}>
                                <td className="text-center fw-bold bg-success text-white"><b>{item.due_date}</b></td>
                                <td className="text-dark"><b>{item.event_name}</b><br></br><small>{item.event_period}</small></td>
                                <td style={{ color: getColor(item.act) }}>{item.act}</td>
                                <td>{item.event_desc}</td>
                              </tr>
                            ))}


                          </tbody>
                        </table>

                      </div>




                    </div>
                  ))}

                </>
              } {data.items && data.items.length == 0 && <TableZero title="Events" />}


            </div>
          </div>
        </div>
      </div>
    </>
  );
}
